import React from "react";
import "./style.scss";

interface Props {
    radius: number,
    source: string | undefined
}

const Avatar: React.FC<Props> = ({
                                     radius,
                                     source
                                 }) => {

    return (
        <div className="avatar" style={{backgroundImage: `url(${source})`, width: radius, height: radius}}/>
    );
};

export default Avatar;
